import React, { useState, useEffect, useRef } from 'react';

function ENDsContainer() {

    return(
        <article className="layout-contents-container">

            <ol className="list-ends">
                <li>
                    <div className="end-item">
                        <div className="info">
                            <time dateTime="" className="date">2020.01.25</time>
                            <span className="category">Essay</span>
                            <strong className="title">ATOPOS PLACE</strong>
                            <p className="copyright">
                                Choi Wook<br/>
                                Architect, Principal<br/>
                                Domus Korea - Editor & Publisher<br/>
                            </p>
                        </div>
                        <div className="contents">
                            <ul className="list-media">
                                <li>
                                    <div className="media">
                                        <div className="inner">
                                            <a href="#" className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div className="description">
                                Even before the city was built, humans have lived in colonial dwellings. Cities are often formed on flat lands with rivers. After establishing a certain range, they build defense walls. Within it, they have fought the opposing problems of solving density and providing citizens with a pleasant function.Cities are often formed on flat lands with rivers. After establishing a certain range, they build defense walls. Within it, they have fought the opposing problems of solving density and providing citizens with a pleasant function. In Roman times, five-storey communal housing was the form of residence for most citizens. The development of private commercial capital gave birth to condominiums in Venice in the 15th century, Apart from the service facilities available in the high-class residences, It started in New York more than 100 years ago. Even before the city was built, humans have lived in colonial dwellings. Cities are often formed on flat lands with rivers. After establishing a cert ain range, they build defense walls. Within it, they have fought the opposing problems of solving density and providing citizens with a pleasant function. In Roman times, five-storey communal housing was the form of residence for most citizens. Even before the city was built, humans have lived in colonial dwellings. Cities are often formed on flat lands with rivers. After establishing a certain range, they build defense walls.
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="end-item">
                        <div className="info">
                            <time dateTime="" className="date">2020.01.25</time>
                            <span className="category">Drawing</span>
                            <strong className="title">ATOPOS PLACE</strong>
                            <p className="description">
                                Choi Wook<br/>
                                Architect, Principal<br/>
                                Domus Korea - Editor & Publisher<br/>
                            </p>
                        </div>
                        <div className="contents">
                            <ul className="list-media">
                                <li>
                                    <div className="media">
                                        <div className="inner">
                                            <a href="#" className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></a>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="media">
                                        <div className="inner">
                                            <a href="#" className="photo"><img src="/assets/images/@temp/@project_01@2x.jpg" alt=""/></a>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ol>

            <div className="list-actions">
                <button type="button" className="button-read-more">Read More</button>
            </div>

        </article>
    );
}

export default ENDsContainer;
